import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import INPUTRADIO from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTRADIO.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../../DOM/form/label/LABEL.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
import Deactivate from '../../../../../../../../event/Deactivate.js';
import Clickable from '../../../../../../../../interface/Clickable.js';
// Model Structure
export const formInputRadioAttr = makeAttrStruct([
    ['class']
]);
export const formInputRadioData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formInputRadioModel = makeStruct([
    ['attributes', formInputRadioAttr],
    ['data', formInputRadioData]
]);
// Simplified Model
export function formInputRadio(label, field, message, className) {
    return {
        attributes: formInputRadioAttr(className),
        data: formInputRadioData(label, field, message)
    };
}
/** Represents an Input[type=Text] for a Form */
export default class FORMINPUTRADIO extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
        this.implement(new Clickable(this));
        if (model.attributes.checked) {
            this.getField().setAttribute('checked', 'true');
        }
        else {
            this.getField().removeAttribute('checked');
        }
        this.on('click', (event) => {
            if (!this.hasClass('active')) {
                this.activateFormField(event);
            }
        }).on('activate', (event) => {
            this.activateFormField(event);
        });
    }
    activateFormField(event) {
        event.stopPropagation();
        this.dispatchToSiblings(new Deactivate(), 'active');
        this.getLabel().el.click();
    }
    createField(model) {
        return new INPUTRADIO(this, model);
    }
}
